/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from "react";

import { withRouter } from "react-router-dom";

import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

import {
  Grid,
  Button,
  Typography,
  Divider,
  Paper,
  Card,
  CardHeader,
  CardContent,
  Chip,
  Tooltip,
  IconButton,
} from "@material-ui/core";

import CheckCircleOutlined from "@material-ui/icons/CheckCircleOutlined";
import HighlightOff from "@material-ui/icons/HighlightOff";
import Add from "@material-ui/icons/Add";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Refresh from "@material-ui/icons/Refresh";
import AutoRenew from "@material-ui/icons/Autorenew";
import AutorenewTwoToneIcon from "@material-ui/icons/AutorenewTwoTone";
import EditOutlined from "@material-ui/icons/EditOutlined";
import SyncAlt from "@material-ui/icons/SyncAlt";
import ExitToAppOutlinedIcon from "@material-ui/icons/ExitToAppOutlined";
import QueryBuilderIcon from "@material-ui/icons/QueryBuilder";
import DynamicFeedIcon from "@material-ui/icons/DynamicFeed";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import NotInterestedIcon from "@material-ui/icons/NotInterested";
import UpdateIcon from "@material-ui/icons/Update";

import MaterialTable, { MTableToolbar } from "material-table";
import table_icons from "../tableIcons";

import Actions from "../../fluid/Actions/ActionFactory";

const styles = (theme) => ({});

const blue_theme = createMuiTheme({
  palette: {
    primary: {
      main: "#2296f3",
    },
    // primary: {
    //     main: "#FF6600",
    //     contrastText: "#FFFFFFFF"
    // },
    secondary: {
      main: "#ff9100",
    },
  },
});

class FinishSetup extends Component {
  state = {
    info_units: [],
    transfer_initiated: false,
    ic_data: {},
    data_received: false,
  };

  componentDidMount() {
    Actions("http_request", {
      url: "/sainapse/information_channel/" + this.props.ic_name,
      method: "get",
      data: {},
    }).then((res) => {
      console.log("API Success: ", res.data.result);
      this.setState(
        { ...this.state, ic_data: res.data.result, data_received: true },
        () => console.log("Finish setup State: ", this.state)
      );
    });
  }

  initiateTransfer = (ic_name, iu_name) => {
    Actions("http_request", {
      url: "/sainapse/train",
      method: "post",
      data: {
        ic_name: ic_name,
        iu_name: iu_name,
      },
    }).then((res) => {
      console.log("Transfer Response: ", res.data);
    });
  };

  renderIUList = () => {
    let list = this.state.info_units.map((iu) => {
      return (
        <Grid item xs={4}>
          <Typography
            style={{ display: "block" }}
            align="center"
            variant="button"
          >
            {iu.name}
          </Typography>
          <ThemeProvider theme={blue_theme}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={() => this.initiateTransfer(this.props.ic_name, iu.name)}
            >
              Initiate Transfer
            </Button>
          </ThemeProvider>
        </Grid>
      );
    });
    return list;
  };

  renderOperations = () => {
    return (
      <Paper
        variant="outlined"
        style={{ backgroundColor: "#FAFBFC", padding: "10px" }}
      >
        <Typography style={{ display: "block" }} variant="overline">
          Operations
        </Typography>
        {this.renderOperationsChips()}
      </Paper>
    );
  };

  renderOperationsChips = () => {
    let ops = this.state.ic_data.operationAnnotations.map((op) => {
      return (
        <ThemeProvider theme={blue_theme}>
          <Chip
            style={{ marginRight: "5px" }}
            color="primary"
            label={op.annotation}
          />
        </ThemeProvider>
      );
    });

    return ops;
  };

  renderWorldView = () => {
    return (
      <Paper
        variant="outlined"
        style={{
          backgroundColor: "#FAFBFC",
          marginTop: "10px",
          padding: "10px",
        }}
      >
        <Typography variant="overline">World View</Typography>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
          }}
        >
          {this.renderWorldViewFields()}
        </div>
      </Paper>
    );
  };

  renderWorldViewFields = () => {
    let fields = this.state.ic_data.world_view.fields.map((field) => {
      return (
        <Paper
          variant="outlined"
          style={{ padding: "8px", marginRight: "8px" }}
        >
          <Typography align="center">{field.name}</Typography>
        </Paper>
      );
    });

    return fields;
  };

  renderInformationUnits = () => {
    return (
      <Paper
        variant="outlined"
        style={{
          backgroundColor: "#FAFBFC",
          marginTop: "10px",
          padding: "10px",
        }}
      >
        <Typography variant="overline">Information Units</Typography>
        {this.renderIUTable()}
      </Paper>
    );
  };

  datatransferIU = (ic_data, iu_data) => {
    console.log("IC Data: ", ic_data);
    console.log("IU Data: ", iu_data);
    let ic_name = ic_data.name;
    let iu_name = iu_data.name;

    Actions("http_request", {
      url: "/sainapse/train/data",
      method: "post",
      data: {},
      params: {
        ic_name: ic_name,
        iu_names: iu_name,
      },
    }).then((res) => {
      this.getData();
      console.log("Data Transfer: ", res.data.result);
    });
  };

  renderIUTable = () => {
    return (
      <MaterialTable
        title="Information Units"
        icons={table_icons}
        columns={[
          { title: "Name", field: "name" },
          {
            title: "Key",
            field: "key",
            render: (rowData) => {
              return (
                <Chip
                  size="small"
                  style={{ backgroundColor: "#2296f3", color: "#FFFFFF" }}
                  label={rowData.key}
                />
              );
            },
          },
          // {title : 'Type', field : 'type', render : rowData => {
          //     return  (
          //         <Chip size = 'small' style = {{backgroundColor : '#2296f3', color : '#FFFFFF' }} label = {rowData.type}/>
          //     )
          // }},
          {
            title: "Access Details",
            field: "access_details",
            render: (rowData) => {
              if (rowData.access_details === null) {
                return (
                  <HighlightOff fontSize="small" style={{ color: "#f44336" }} />
                );
              } else {
                return (
                  <CheckCircleOutlined
                    fontSize="small"
                    style={{ color: "#4caf50" }}
                  />
                );
              }
            },
          },
          {
            title: "Adaptor Inputs",
            field: "access_parameters",
            render: (rowData) => {
              if (rowData.access_parameters === null) {
                return (
                  <HighlightOff fontSize="small" style={{ color: "#f44336" }} />
                );
              } else {
                return (
                  <CheckCircleOutlined
                    fontSize="small"
                    style={{ color: "#4caf50" }}
                  />
                );
              }
            },
          },
          {
            title: "Fields In Scope",
            field: "fields_in_scope",
            render: (rowData) => {
              if (rowData.fields_in_scope === null) {
                return (
                  <HighlightOff fontSize="small" style={{ color: "#f44336" }} />
                );
              } else {
                return (
                  <CheckCircleOutlined
                    fontSize="small"
                    style={{ color: "#4caf50" }}
                  />
                );
              }
            },
          },
          {
            title: "World View Map",
            field: "iu_world_view",
            render: (rowData) => {
              if (rowData.iu_world_view === null) {
                return (
                  <HighlightOff fontSize="small" style={{ color: "#f44336" }} />
                );
              } else {
                return (
                  <CheckCircleOutlined
                    fontSize="small"
                    style={{ color: "#4caf50" }}
                  />
                );
              }
            },
          },
          // {title: 'Actions', field : 'name', render : rowData => {
          //     return (
          //         <Tooltip title = 'Initiate Data Transfer'>
          //             <IconButton
          //                 disabled = {
          //                     (rowData.access_details !== null) &&
          //                     (rowData.access_parameters !== null) &&
          //                     (rowData.fields_in_scope !== null) &&
          //                     (rowData.iu_world_view !== null) ? false : true
          //                 }
          //                 size = 'small'
          //                 style = {{
          //                     color : (rowData.access_details !== null) &&
          //                             (rowData.access_parameters !== null) &&
          //                             (rowData.fields_in_scope !== null) &&
          //                             (rowData.iu_world_view !== null) ? '#039be5' : null

          //                 }}>
          //                 <ExitToAppOutlinedIcon fontSize = 'small' onClick = {() => this.datatransferIU(this.state.ic_data, rowData)}/>
          //             </IconButton>
          //         </Tooltip>
          //     )
          // }}
        ]}
        data={this.state.ic_data.information_units}
        options={{
          search: false,
          toolbar: false,
          showTitle: false,
          paging: false,
        }}
      />
    );
  };

  renderExit = () => {
    return (
      <ThemeProvider theme={blue_theme}>
        <Button
          style={{ marginTop: "10px", marginBottom: "10px" }}
          variant="contained"
          color="primary"
          fullWidth
          onClick={this.exitSetup}
        >
          Exit Setup
        </Button>
      </ThemeProvider>
    );
  };

  renderContent = () => {
    if (this.state.data_received === true) {
      return (
        <div>
          {this.renderOperations()}
          {this.renderWorldView()}
          {this.renderInformationUnits()}
          {this.renderExit()}
        </div>
      );
    } else {
      return (
        <Typography variant="body2" color="textSecondary">
          <em>Fetching Information Channel Data</em>
        </Typography>
      );
    }
  };

  exitSetup = () => {
    this.props.history.push({
      pathname: "/ic",
    });
  };

  render() {
    const { classes } = this.props;
    return (
      <div
        style={{
          width: "100%",
          maxHeight: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          overflow: "scroll",
        }}
      >
        <Card style={{ width: "75%", margin: "8px" }}>
          <CardHeader
            title={this.props.ic_name}
            subheader="Information Channel"
            titleTypographyProps={{
              variant: "button",
            }}
            subheaderTypographyProps={{
              variant: "overline",
            }}
            // action = {
            //     <Fragment>
            //         <ThemeProvider theme = {blue_theme}>
            //             <Tooltip title = "Train">
            //                 <IconButton size = 'medium' color = 'primary'>
            //                     <AutorenewTwoToneIcon />
            //                 </IconButton>
            //             </Tooltip>
            //         </ThemeProvider>
            //     </Fragment>
            // }
          />
          <CardContent>{this.renderContent()}</CardContent>
        </Card>
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(FinishSetup));
